export const getPlaceholderColor = (stylers, errors, focused, disabled) => {
    const colorErrors = errors && errors.length ? stylers.inputError?.color || 'var(--color-error)' : false;
    const colorDisabled = disabled ? stylers.inputDisabled?.color || 'var(--color-disabled)' : false;
    const colorFocus = focused ? stylers.inputFocus?.color || 'var(--color-focus)' : false;
    const colorDefault = stylers.input?.color || 'var(--color)';

    const color = colorErrors || colorDisabled || colorFocus || colorDefault;

    return { color };
};
export const getDefaultVariation = (context, title) => (title ? 'couple_title' : 'no_title');
export const getIsCoupleVariation = (variation) => ['couple_title'].includes(variation);
